import React, { useEffect, useState, useRef, useCallback } from "react";
import Header from "../../../components/Header";
import AdminContainer from "../../../containers/Admin";
import CountCard from "../../../components/CounterCard";
import CustomTabs from "../../../components/Tab";
import { useNavigate, useParams } from "react-router-dom";
import { OPERTIONS_URL } from "../../../common/common";
import { bookingStatus } from "../../../common/staticData";
import { ClientTabs } from "../../../common/tabs";
import { Plus, downArrow } from "../../../common/svg";
import Filter from "../../../components/FilterButton";
import Notification from "../../Notification";
import ReportButton from "../../../components/ReportButton";
import CustomButton from "../../../components/AddButton/index";
import DateTimePicker from "../../../components/Date&Time";
import Trip from "./Trip";
import { ApiService } from "../../../service/api.service";
import AllBooking from "../../Booking/components/AllBooking";
import UnderConstruction from "../../../components/UnderConstruction/UnderConstruction";
import SecureImage from "../../../components/BucketImage/Image";

const ClientViewPage = () => {
  const entityId = localStorage.getItem("entity_id");

  const [activeTab, setActiveTab] = useState<string>("Booking");
  const [isExpanded, setIsExpanded] = useState(false);

  const [clientData, setClientData] = useState<any>([]);
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const apiService = new ApiService();
  const { id } = useParams();
  const navigate = useNavigate();

  const observer = useRef<IntersectionObserver | null>(null);
  const lastBookingRef = useRef<HTMLDivElement | null>(null);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleTabChange = (tab: string) => {
    if (tab) {
      setActiveTab(tab);
    }
  };

  // ✅ Fetch Client Data with proper async handling
  const getClientData = async () => {
    try {
      const response: any = await apiService.getApi(
        `${OPERTIONS_URL}/client/details-route?clientId=${id}`
      );

      if (response?.status === "200") {
        const clientInfo = response.body[0] || response.body;
        setData(clientInfo);

        if (clientInfo?.companyDetail) {
          const obj = [
            {
              label: "Client Mail ID",
              value: clientInfo.companyDetail.emailId || "N/A",
            },
            {
              label: "Company",
              value: clientInfo.companyDetail.firstName || "N/A",
            },
            {
              label: "GST",
              value: clientInfo.companyDetail.gstNumber || "N/A",
            },
            {
              label: "Phone No",
              value: `${clientInfo.companyDetail.countryCode || ""} ${clientInfo.companyDetail.phoneNumber || "N/A"
                }`,
            },
            {
              label: "Location",
              value: clientInfo.companyDetail.city || "N/A",
            },
          ];
          setClientData(obj);
        }
      }
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };

  useEffect(() => {
    if (id) getClientData();
  }, [id]);

  return (
    <div>
      <Header
        profile="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
        subtitle={data?.companyDetail?.firstName || "Client"}
        showSearch={false}
        contact={`${data?.companyDetail?.countryCode || ""}${data?.companyDetail?.phoneNumber || ""
          }`}
      >
        <div className="flex gap-2">
          <DateTimePicker />
          <Filter />
          <ReportButton />
          <CustomButton
            label=""
            icon={Plus}
            onClick={() => navigate("newtrip")}
          />
          <Notification />
        </div>
      </Header>

      <AdminContainer>
        <div className="bg-white rounded-[20px] pt-2">
          <div className="flex justify-around p-4">
            {bookingStatus.map((status, index) => (
              <CountCard
                key={index}
                count={status.count}
                label={status.lable}
                backgroundColor={status.backgroundColor}
                textColor={status.textColor}
                className="w-[16%] gap-3 !text-[14px]"
              />
            ))}
          </div>

          <div
            className={`transition-all duration-300 ease-in-out overflow-hidden ${isExpanded ? "max-h-[500px]" : "max-h-0"
              }`}
          >
            <div className="flex justify-around p-2 mt-4">
              {clientData.map(
                (detail: { label: string; value: string }, index: number) => (
                  <div key={index} className="flex flex-col items-center">
                    <div className="text-[#7E7E7E] font-[400] text-[14px]">
                      {detail.label}
                    </div>
                    <div className="font-[500] text-[14px]">{detail.value}</div>
                  </div>
                )
              )}
            </div>
          </div>

          <div className="flex justify-center items-center mt-2 relative">
            <button
              onClick={toggleExpand}
              aria-expanded={isExpanded}
              className="flex justify-center items-center bg-white w-[30px] h-[30px] absolute bottom-[-1] rounded-full shadow-[0px_0.5px_1px_0.5px_rgba(0,0,0,0.25)]"
            >
              <SecureImage
                fileKey={downArrow}
                alt={isExpanded ? "Collapse" : "Expand"}
                className={`transition-transform duration-300 ${isExpanded ? "rotate-180" : ""
                  }`}
                width="20px"
              />
            </button>
          </div>
        </div>

        <br />

        <CustomTabs
          tabs={ClientTabs}
          initialActiveTab="Booking"
          onTabChange={handleTabChange}
        />

        <br />

        <div>
          {activeTab === "Booking" && (
            <>
              <AllBooking id={id} />
              <div ref={lastBookingRef} className="h-10"></div>
            </>
          )}
          {activeTab === "Trips" && <Trip />}
          {activeTab === "Routes" && <UnderConstruction />}
          {activeTab === "Commodities" && <UnderConstruction />}
          {activeTab === "Payments" && <UnderConstruction />}
          {activeTab === "Documents" && <UnderConstruction />}
          {activeTab === "Other Details" && <UnderConstruction />}
        </div>
      </AdminContainer>
    </div>
  );
};

export default ClientViewPage;
